import { render, staticRenderFns } from "./MoleculeEditionBillingMyPayments.vue?vue&type=template&id=70d196d0"
import script from "./MoleculeEditionBillingMyPayments.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingMyPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports